import { useState, useEffect } from 'react';
import { getTables } from '../api/tables.api.js';
import { IcoClose } from './common/Icons.jsx';
import styles from './MoveTabSheet.module.css';

// Elegir mesa desde el carrito.
//
// Hasta ahora la mesa solo se asignaba desde el plano: si el mesero ya venía
// capturando y se acordaba de que era para la Mesa 6, tenía que salirse. En la
// comandera cuesta más todavía, porque el carrito es una hoja que tapa media
// pantalla.
//
// Es hermana de MoveTabSheet pero no la misma: aquella opera sobre una cuenta
// que ya existe y ofrece juntarla con otra. Aquí puede que ni siquiera haya
// cuenta —el carrito está suelto— así que juntar no significa nada todavía.
// Reusa su hoja de estilos para que se vean iguales.
export default function AssignTableSheet({ open, tabId, onAssign, onClose }) {
  const [mesas,    setMesas]    = useState([]);
  const [error,    setError]    = useState(null);
  const [enviando, setEnviando] = useState(null);

  useEffect(() => {
    if (!open) return;
    setError(null);
    getTables().then((r) => setMesas(r.data ?? [])).catch(() => setMesas([]));
  }, [open]);

  if (!open) return null;

  // Una mesa que ya trae otra cuenta no se ofrece: el servidor la rechazaría
  // con 409 y el mesero se llevaría el viaje en balde.
  const libres = mesas.filter((m) => !m.occupancy || (tabId && m.occupancy.tab_id === tabId));

  const elegir = async (mesa) => {
    setEnviando(mesa._id); setError(null);
    try {
      await onAssign(mesa);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error ?? 'No se pudo asignar la mesa');
    } finally {
      setEnviando(null);
    }
  };

  const porZona = libres.reduce((acc, m) => {
    (acc[m.zone || 'Sin zona'] ||= []).push(m);
    return acc;
  }, {});

  return (
    <div className={styles.scrim} role="presentation" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.sheet} role="dialog" aria-modal="true">
        <div className={styles.head}>
          <div>
            <h2 className={styles.title}>Asignar mesa</h2>
            <p className={styles.sub}>Lo que llevas en el carrito se queda en esa mesa.</p>
          </div>
          <button className={styles.close} onClick={onClose} aria-label="Cerrar"><IcoClose size={16} /></button>
        </div>

        <div className={styles.lista}>
          {error && <p className={styles.error}>{error}</p>}
          {libres.length === 0 && <p className={styles.vacio}>No hay mesas libres.</p>}

          {/* Agrupadas por zona: el mesero piensa "terraza 3", no "mesa 11". */}
          {Object.entries(porZona).map(([zona, ms]) => (
            <div key={zona}>
              <p className={styles.sub} style={{ margin: "6px 0 2px" }}>{zona}</p>
              {ms.map((m) => (
                <button
                  key={m._id}
                  className={styles.opcion}
                  disabled={enviando !== null}
                  onClick={() => elegir(m)}
                >
                  <strong>{m.name}</strong>
                  <small>{m.seats} {m.seats === 1 ? 'lugar' : 'lugares'}{enviando === m._id ? ' · asignando…' : ''}</small>
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
